import React from 'react';
import { TableCell, TableSortLabel } from '@mui/material';
import { TaskSortColumn, SortDirection } from 'store/taskSortSlice';

interface SortableTaskHeaderProps {
  column: TaskSortColumn;
  label: string;
  currentSortColumn: TaskSortColumn;
  sortDirection: SortDirection;
  onSort: (column: TaskSortColumn) => void;
  align?: 'left' | 'center' | 'right';
}

/**
 * Sortable table header for task list columns.
 * Integrates with taskSortSlice for sort state management.
 * Toggles sort direction when clicked.
 */
export default function SortableTaskHeader({
  column,
  label,
  currentSortColumn,
  sortDirection,
  onSort,
  align = 'left'
}: SortableTaskHeaderProps) {
  const isActive = currentSortColumn === column;

  return (
    <TableCell 
      align={align}
      sx={{
        borderBottom: 'none'
      }}
    >
      <TableSortLabel
        active={isActive}
        direction={isActive ? sortDirection : 'asc'}
        onClick={() => onSort(column)}
        sx={{
          '&:hover': {
            color: 'inherit',
          },
          '&.Mui-active': {
            color: 'inherit',
            '& .MuiTableSortLabel-icon': {
              opacity: 1,
            },
          },
        }}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );
}